<template @click="toggleMobileNav">
  <section class="wrapper_type_2">
    <SuspendedModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></SuspendedModal>
    <WarningModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></WarningModal>
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand
        href="#"
        class="hamburger_container d-flex justify-content-between"
        :style="[
          statusInfo.status && statusInfo.status == 1
            ? { marginRight: '50px !important' }
            : null,
        ]"
      >
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>

        <!-- SELECT LANGUAGE -->
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-50 d-lg-none mb-3 mb-md-3 mb-sm-5 mb-lg-0"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
          @change="changeLanguage"
          class="w-50 d-lg-none mb-3 mb-md-3 mb-lg-0 mr-3"
        >
          <option disabled value="">
            {{ $t("text.cMasterLayout.selectLanguage") }}
          </option>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select> -->
      </b-navbar-brand>

      <div
        style="margin: 0 auto; margin-left: 100px; margin-right: 50px"
        class="m-hide"
      >
        <p class="text-center display-flex branchName" style="margin-bottom: 0">
          <span class="" style="font-size: 25px">{{ branch.name }} </span>
          <star-rating
            class="ml-2"
            v-model="branchRating"
            :show-rating="true"
            :read-only="true"
            :star-size="starSize"
            :fixed-points="2"
            :round-start-rating="false"
          ></star-rating>
        </p>
      </div>

      <b-collapse id="nav-collapse" is-nav>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 1"
          class="payment_due_text"
        >
          {{ $t("text.subscribe.expireIn") }}
          <span class="payment_due_date">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span
          >, {{ $t("text.subscribe.makePayment") }}
        </b-nav-item>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 2"
          class="payment_due_text"
        >
          {{ $t("text.subscribe.expired") }}
        </b-nav-item>
        <b-navbar-nav class="ml-auto desk-view">
          <b-nav-item
            href="#"
            class="bell_noti"
            style="position: relative"
            v-if="statusInfo.status && statusInfo.status !== 0"
            @click="showNotification"
          >
            <img src="@/assets/img/notification.svg" width="28" />
          </b-nav-item>
          <!-- <b-nav-item 
            v-b-tooltip.hover title="Servcie transactions"
            >
               <router-link
                  :to="{ name: 'CreateBranchTransaction', query: {companyId: $route.query.companyId, branchId: $route.query.branchId}}"
                  class="mr-3"
                  >
                     <img  src="@/assets/img/cart.png" width="35" class="mr-3" />
                    <b-badge variant="primary" class="cart-count">
                    {{$store.getters.getBanchTransactions.length}} 
                    </b-badge>
                </router-link>
            </b-nav-item> -->

          <!-- SELECT LANGUAGE -->
          <select
            @change="changeLanguage"
            v-model="usedLang"
            class="w-100 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
          >
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select>
          <!-- <select
            @change="changeLanguage"
            class="mr-3"
            style="width: 280px !important"
          >
            <option disabled value="">
              {{ $t("text.cMasterLayout.selectLanguage") }}
            </option>
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select> -->

          <b-nav-item href="#"
            ><img v-if="companyIcon" :src="companyIcon" height="30px" />
            <img
              v-if="!companyIcon"
              src="@/assets/img/avatar.svg"
              height="30px"
            />
          </b-nav-item>

          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#" @click="changeRoute('branchProfile')">
              <router-link
                :to="{
                  name: 'branchSettings',
                  query: this.$route.query.branchId
                    ? {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      }
                    : null,
                }"
              >
                {{ $t("text.bMasterLayout.settings") }}
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="changeRoute('branchProfile')">{{
              $t("text.bMasterLayout.profile")
            }}</b-dropdown-item>
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.bMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="mt-3 text-right m-hide-icon">
        <img
          src="@/assets/img/close_btn.png"
          width="35px"
          height="35px"
          @click="toggleCollapsibleNavBar"
          id="mySidenav"
        />
      </div>
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>
        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="35" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <!-- COMPANY DASHBOARD -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'companyDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.branchId &&
              (userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'companyDashboard',
                query: { companyId: $route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.companyDashboard") }}
              </span>
            </router-link>
          </li>
          <!-- When youre coming from dealer dashboard to branch dashboard -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'dealerDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.branchId &&
              $route.query.dealerId &&
              (userDetails.roles.includes('Dealers') ||
                userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'dealerDashboard',
                query: this.$route.query.dealerId
                  ? {
                      dealerId: this.$route.query.dealerId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.dealerDashboard") }}
              </span>
            </router-link>
          </li>

          <!-- When youre coming from group dashboard to branch dashboard -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'groupDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.branchId &&
              $route.query.groupId &&
              (userDetails.roles.includes('SalesRep') ||
                userDetails.roles.includes('RegionalEngineer') ||
                userDetails.roles.includes('Team') ||
                userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'groupDashboard',
                query: this.$route.query.groupId
                  ? {
                      groupId: this.$route.query.groupId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.groupDashboard") }}
              </span>
            </router-link>
          </li>
          <!-- When youre coming from region dashboard to branch dashboard -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'regionDashboard' ? 'navbar_item_active' : ''
            "
            v-if="
              $route.query.branchId &&
              $route.query.regionId &&
              (userDetails.roles.includes('RegionalManager') ||
                userDetails.roles.includes('Company') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'regionDashboard',
                query: this.$route.query.regionId
                  ? {
                      regionId: this.$route.query.regionId,
                      companyId: $route.query.companyId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.regionDashboard") }}
              </span>
            </router-link>
          </li>
          <!-- BRANCH DASHBOARD -->
          <li
            v-show="
              allowedEmails.indexOf(userDetails.email) === -1 &&
              (userDetails.roles.includes('ManageOutlet') ||
                userDetails.roles.includes('Branch') ||
                userDetails.roles.includes('Company') ||
                userDetails.roles.includes('Dealers') ||
                userDetails.roles.includes('DealerManageBranch') ||
                userDetails.roles.includes('SalesRep') ||
                userDetails.roles.includes('Team') ||
                userDetails.roles.includes('RegionalManager') ||
                userDetails.roles.includes('RegionalEngineer') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            class="list-group-item"
            :class="
              activeRoute === 'branchDashboard' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'branchDashboard',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/dashboard (2).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>

          <!-- UPDATE PRICE -->
          <li
            class="list-group-item"
            :class="activeRoute === 'manage_price' ? 'navbar_item_active' : ''"
            v-if="
              (userDetails.roles.includes('BranchPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              (userDetails.roles.includes('DealerUpdateBranchPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              (userDetails.roles.includes('CompanyPrice') &&
                comPlanFeatures.includes('Update Price')) ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'manage_price',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.updatePrice") }}
              </span>
            </router-link>
          </li>

          <!-- SPECIFIC SALES REPORT FOR DEMO BRANCH -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'BranchSalesTransactions'
                ? 'navbar_item_active'
                : ''
            "
            v-show="
              userDetails.email == 'supportest@gmail.com' &&
              (userDetails.roles.includes('BranchReport') ||
                userDetails.roles.includes('DealerViewBranchReport') ||
                userDetails.roles.includes('ManageOutlet') ||
                userDetails.roles.includes('ViewOutlet') ||
                userDetails.roles.includes('SalesReport') ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'BranchSalesTransactions',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/profit-report (1).svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cDashboard.salesReport") }}
              </span>
            </router-link>
          </li>

          <!-- PRICE CHANGE LOG -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'manage_price_log' ? 'navbar_item_active' : ''
            "
            v-if="userDetails.roles.includes('Price Log')"
          >
            <router-link
              :to="{
                name: 'manage_price_log',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.omit.priceChangeLog") }}
              </span>
            </router-link>
          </li>

          <!-- PUMP CALIBRATION -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'branch_pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              (userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'branch_pump_calibration_logs'
                ? 'navbar_item_active'
                : ''
            "
            v-if="
              (userDetails.roles.includes('Company') &&
                comPlanFeatures.includes('Pump calibration')) ||
              (userDetails.roles.includes('ManageOutlet') &&
                comPlanFeatures.includes('Pump calibration')) ||
              (userDetails.roles.includes('ViewOutlet') &&
                comPlanFeatures.includes('Pump calibration')) ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          > -->
            <router-link
              :to="{
                name: 'branch_pump_calibration_logs',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/measure.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.pumpsCalibration.title") }}
              </span>
            </router-link>
          </li>

          <!-- REPORTS -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('BranchReport') &&
                comPlanFeatures.includes('Report')) ||
                (userDetails.roles.includes('DealerViewBranchReport') &&
                  comPlanFeatures.includes('Report')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Report')) ||
                (userDetails.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Report')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'tank_reports' ||
              activeRoute === 'shift_transactions' ||
              activeRoute === 'end_of_the_day_report' ||
              activeRoute === 'productSummary' ||
              activeRoute === 'salesTransactionSummary' ||
              activeRoute === 'BranchSalesTransactions' ||
              activeRoute === 'TanksFilledReport' ||
              activeRoute === 'VarianceReport' ||
              activeRoute === 'branchTankVariance' ||
              activeRoute === 'branch_POS' ||
              activeRoute === 'branch_cash_flow' ||
              activeRoute === 'branch_stock_valuation' ||
              activeRoute === 'branch_products_filled' ||
              activeRoute === 'branch_products_received' ||
              activeRoute === 'pump-summary' ||
              activeRoute === 'branch_wallet' ||
              activeRoute === 'branch_bank_deposits' ||
              activeRoute === 'BranchRetainershipSales' ||
              activeRoute === 'branch-product-sales'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/profit-report (1).svg" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.report") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul
                v-show="
                  userDetails.roles.includes('BranchReport') ||
                  userDetails.roles.includes('DealerViewBranchReport') ||
                  userDetails.roles.includes('ManageOutlet') ||
                  userDetails.roles.includes('ViewOutlet') ||
                  userDetails.roles.includes('SalesReport') ||
                  userDetails.roles.includes('SupportAdmin') ||
                  userDetails.roles.includes('PartnerAdmin')
                "
                class="treeview-menu"
              >
                <!-- SALES REPORT -->
                <li class="treeview-men">
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.cDashboard.salesReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('SalesReport') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'BranchSalesTransactions',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.salesTransactions") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'end_of_the_day_report',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.endOfDayReport") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'productSummary',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.productSummary") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'branch-product-sales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.productSales") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'PumpTankReport',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.branch.pump") }}
                          {{ $t("text.pumpsFault.tank") }}
                          {{ $t("text.cMasterLayout.report") }}
                        </router-link>
                      </li>
                      <!-- <li>
                        <router-link
                          :to="{
                            name: 'branchTankVariance',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.tanksVariance") }}
                        </router-link>
                      </li> -->
                      <li>
                        <router-link
                          :to="{
                            name: 'VarianceReport',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.pumpsVariance") }}
                        </router-link>
                      </li>
                      <li
                        v-if="
                          userDetails.roles.includes('viewESales') ||
                          userDetails.roles.includes('ManageBranchPayments') ||
                          userDetails.roles.includes(
                            'DealerManageBranchPayments',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('SalesRep') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('SalesReport') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'branch_wallet',
                            query: {
                              branchId: this.$route.query.branchId,
                              companyId: $route.query.companyId,
                              dealerId: this.$route.query.dealerId,
                              groupId: this.$route.query.groupId,
                              regionId: this.$route.query.regionId,
                            },
                          }"
                          class="vue_router_link"
                        >
                          <!-- {{ $t("text.bMasterLayout.eSales") }} -->
                          {{ $t("text.omit.remisSales") }}
                        </router-link>
                      </li>
                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('SalesReport') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'BranchRetainershipSales',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.endOfDayReport.retainershipSales") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- CASH REPORT -->
                <li class="treeview-men">
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.cDashboard.cashReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'branch_cash_flow',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.cashFlowReport") }}
                        </router-link>
                      </li>
                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('POS Report') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'branch_POS',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.posReport") }}
                        </router-link>
                      </li>
                      <li
                        v-if="
                          userDetails.roles.includes('ManageBranchPayments') ||
                          userDetails.roles.includes(
                            'DealerManageBranchPayments',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'branch_bank_deposits',
                            query: {
                              branchId: this.$route.query.branchId,
                              companyId: $route.query.companyId,
                              dealerId: this.$route.query.dealerId,
                              groupId: this.$route.query.groupId,
                              regionId: this.$route.query.regionId,
                            },
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.bankDeposits") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- INVENTORY REPORT -->
                <li
                  v-show="
                    userDetails.roles.includes('BranchReport') ||
                    userDetails.roles.includes('DealerViewBranchReport') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                  class="treeview-men"
                >
                  <a
                    href="#"
                    class="font-weight-bold vue_router_link has-submenu"
                  >
                    {{ $t("text.bMasterLayout.inventoryReport") }}
                    <i class="fa fa-angle-left sidenav_arrow"></i>
                  </a>

                  <div>
                    <ul class="treeview-menu-one ml-2">
                      <li>
                        <router-link
                          :to="{
                            name: 'tank_reports',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.tankReport") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'branchTankVariance',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.tanksVariance") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'branch_tanks_filled',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.products.productDischarged") }}
                        </router-link>
                      </li>
                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('Inventory Report') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'tank_dippings',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.tankDippings") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'branch_products_received',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.productsReceived") }}
                        </router-link>
                      </li>
                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('Inventory Report') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'branch_products_filled',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.productsFilled") }}
                        </router-link>
                      </li>

                      <li
                        v-show="
                          userDetails.roles.includes('BranchReport') ||
                          userDetails.roles.includes(
                            'DealerViewBranchReport',
                          ) ||
                          userDetails.roles.includes('ManageOutlet') ||
                          userDetails.roles.includes('ViewOutlet') ||
                          userDetails.roles.includes('Inventory Report') ||
                          userDetails.roles.includes('SupportAdmin') ||
                          userDetails.roles.includes('PartnerAdmin')
                        "
                      >
                        <router-link
                          :to="{
                            name: 'inventory-report',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.inventoryReport") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'branch_stock_valuation',
                            query: this.$route.query.branchId
                              ? {
                                  branchId: this.$route.query.branchId,
                                  companyId: $route.query.companyId,
                                  dealerId: this.$route.query.dealerId,
                                  groupId: this.$route.query.groupId,
                                  regionId: this.$route.query.regionId,
                                }
                              : null,
                          }"
                          class="vue_router_link"
                        >
                          {{ $t("text.bMasterLayout.stockValuation") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- <li>
                  <router-link
                    :to="{
                      name: '#',
                    }"
                    class="vue_router_link font-weight-bold"
                  >
                    SALES REPORT
                  </router-link>
                </li> -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'BranchSalesTransactions',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.salesTransactions") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'end_of_the_day_report',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.endOfDayReport") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'productSummary',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.productSummary") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch-product-sales',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.productSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'PumpTankReport',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.branch.pump") }}
                    {{ $t("text.pumpsFault.tank") }}
                    {{ $t("text.cMasterLayout.report") }}
                  </router-link>
                </li> -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'branch_cash_flow',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.cashFlowReport") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_POS',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.posReport") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branch_bank_deposits',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.bankDeposits") }}
                  </router-link>
                </li> -->

                <!-- <li>
                  <router-link
                    :to="{
                      name: 'tank_reports',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.tankReport") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_tanks_filled',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.products.productDischarged") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'tank_dippings',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.tankDippings") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_products_received',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.productsReceived") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_products_filled',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.productsFilled") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branchTankVariance',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.tanksVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'VarianceReport',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.pumpsVariance") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'inventory-report',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.inventoryReport") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_stock_valuation',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.stockValuation") }}
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link
                    :to="{
                      name: 'pump-summary',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.pumpSummary") }}
                  </router-link>
                </li> -->
              </ul>
            </div>
          </li>

          <!-- MANUAL RECORDS -->
          <li
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('manualRecords') &&
                comPlanFeatures.includes('Manual records')) ||
                (userDetails.roles.includes('DealerManageManualRecords') &&
                  comPlanFeatures.includes('Manual records')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'manualRecord' ||
              activeRoute === 'rejectedRecord' ||
              activeRoute === 'non-wet-product-Sales' ||
              activeRoute === 'branch-services' ||
              activeRoute === 'branch_Lease'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/folder.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.manualRecords") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'manualRecord',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'manualRecord' ? 'navbar_item_active' : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.manualRecords") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'rejectedRecord',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'rejectedRecord'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.rejectedEODrecord") }}
                  </router-link>
                </li>
                <li
                  v-show="
                    (userDetails.roles.includes('manualRecords') &&
                      comPlanFeatures.includes('Manual records')) ||
                    (userDetails.roles.includes('DealerManageManualRecords') &&
                      comPlanFeatures.includes('Manual records')) ||
                    userDetails.roles.includes('canManageNonWetProducts') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'NonWetProductsBranchSales',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'rejectedRecord'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.dryStockSales") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch-services',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'rejectedRecord'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.manageServices") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_Lease',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'rejectedRecord'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.leases") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'BranchSpace',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.availableSpaces") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'Occupants',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.availableOccupants") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- TANKS -->
          <li
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('BranchTank') &&
                comPlanFeatures.includes('Tank')) ||
                (userDetails.roles.includes('DealerViewBranchTank') &&
                  comPlanFeatures.includes('Tank')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Tank')) ||
                (userDetails.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Tank')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            class="list-group-item treeview"
            :class="
              activeRoute === 'tanks' ||
              activeRoute === 'tanks_probe_transactions' ||
              activeRoute === 'tanks_daily_report' ||
              activeRoute === 'branch-sufficiency'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/tanks_icon.png" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.tanks") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'tanks',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="activeRoute === 'tank' ? 'navbar_item_active' : ''"
                  >
                    {{ $t("text.bMasterLayout.tanks") }}
                  </router-link>
                </li>
                <!-- SUFFICIENCY METRICS -->
                <li>
                  <router-link
                    :to="{
                      name: 'branch-sufficiency',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'branch-sufficiency'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.sufficiencyMetrics") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <!-- <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'BranchRatings' ||
              activeRoute === 'BranchRatingsBreakdown'
                ? 'navbar_item_active'
                : null
            "
            v-if="!userDetails.roles.includes('Sub Branch Manager')"
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/rating.png" width="30" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.ratings") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'BranchRatings',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.branchRating") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'BranchRatingsBreakdown',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.branchRatingsBreakdown") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'staffRatings',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: this.$route.query.companyId,
                            dealerId: this.$route.query.dealerId,
                            groupId: this.$route.query.groupId,
                            regionId: this.$route.query.regionId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'companyRetainership'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.staffRatings") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li> -->
          <!-- <li
            class="list-group-item"
            :class="activeRoute === 'tanks' ? 'navbar_item_active' : ''"
            v-if="
              userDetails.roles.includes('BranchTank') ||
              userDetails.roles.includes('DealerViewBranchTank') ||
              userDetails.roles.includes('ManageOutlet') ||
              userDetails.roles.includes('ViewOutlet') ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'tanks',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img alt="" src="@/assets/img/tanks_icon.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.tanks") }}
              </span>
            </router-link>
          </li> -->

          <!-- SUFFICIENCY METRICS -->

          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'branch-sufficiency' ? 'navbar_item_active' : ''
            "
            v-if="
              userDetails.roles.includes('BranchTank') ||
              userDetails.roles.includes('DealerViewBranchTank') ||
              userDetails.roles.includes('ManageOutlet') ||
              userDetails.roles.includes('ViewOutlet') ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'branch-sufficiency',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><svg
                  width="35"
                  height="35"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 0C10.751 0 0 10.751 0 24C0 37.249 10.751 48 24 48C37.249 48 48 37.249 48 24C48 10.751 37.249 0 24 0ZM24 1C36.708 1 47 11.292 47 24C47 36.709 36.708 47 24 47C11.292 47 1 36.709 1 24C1 11.292 11.292 1 24 1ZM24.5 12C24.3674 12 24.2402 12.0527 24.1464 12.1464C24.0527 12.2402 24 12.3674 24 12.5V14H23.5C23.3674 14 23.2402 14.0527 23.1464 14.1464C23.0527 14.2402 23 14.3674 23 14.5V16H21V13.506C21 13.3734 20.9473 13.2462 20.8536 13.1524C20.7598 13.0587 20.6326 13.006 20.5 13.006C20.3674 13.006 20.2402 13.0587 20.1464 13.1524C20.0527 13.2462 20 13.3734 20 13.506V16H15V16.025C11.642 16.285 9.033 19.323 9.033 23C9.033 25.541 10.283 27.773 12.16 29H8.506C8.3718 29 8.2431 29.0533 8.1482 29.1482C8.05331 29.2431 8 29.3718 8 29.506V31.496C8 31.776 8.226 32.002 8.506 32.002H11.187L12.049 33.725C12.0907 33.8078 12.1546 33.8773 12.2335 33.9259C12.3125 33.9744 12.4033 34.0001 12.496 34H13.046C13.1634 34.5635 13.4709 35.0694 13.9169 35.4332C14.363 35.7969 14.9205 35.9963 15.496 35.998C16.0717 35.9959 16.6293 35.796 17.0753 35.432C17.5213 35.0679 17.8287 34.5616 17.946 33.998H18.496C18.5887 33.9981 18.6796 33.9724 18.7585 33.9239C18.8374 33.8753 18.9013 33.8058 18.943 33.723L19.805 32H28.195L29.057 33.723C29.0987 33.8058 29.1626 33.8753 29.2415 33.9239C29.3204 33.9724 29.4113 33.9981 29.504 33.998H30.057C30.174 34.5617 30.4811 35.068 30.927 35.4321C31.3729 35.7962 31.9303 35.996 32.506 35.998C33.0818 35.9962 33.6395 35.7966 34.0856 35.4324C34.5317 35.0683 34.839 34.5618 34.956 33.998H35.504C35.5967 33.9981 35.6875 33.9724 35.7665 33.9239C35.8454 33.8753 35.9093 33.8058 35.951 33.723L36.812 32H39.494C39.774 32 40 31.774 40 31.494V29.02H39.494V29H35.84C37.718 27.773 38.967 25.541 38.967 23C38.967 19.154 36.116 16 32.535 16H29V14.5C29 14.3674 28.9473 14.2402 28.8536 14.1464C28.7598 14.0527 28.6326 14 28.5 14H28V12.5C28 12.3674 27.9473 12.2402 27.8536 12.1464C27.7598 12.0527 27.6326 12 27.5 12H24.5ZM25 13H27V14H25V13ZM24 15H28V16H24V15ZM16 17H17V29H16V17ZM18 17H30V29H18V17ZM31 17H32V29H31V17ZM15 17.025V28.975C12.224 28.717 10.033 26.18 10.033 23C10.033 19.82 12.224 17.283 15 17.025ZM33 17.025C35.776 17.283 37.967 19.82 37.967 23C37.967 26.18 35.776 28.717 33 28.975V17.025ZM9.012 30.012H38.988V30.99H9.012V30.012ZM12.307 32.002H13.507C13.287 32.294 13.123 32.629 13.047 33H12.807L12.307 32.002ZM15.477 32.002H15.516C16.341 32.013 16.996 32.672 16.996 33.5C16.996 34.334 16.33 35 15.496 35C14.662 35 13.996 34.334 13.996 33.5C13.996 32.672 14.652 32.012 15.476 32.002H15.477ZM17.484 32.002H18.687L18.187 33H17.945C17.8684 32.6371 17.7112 32.296 17.485 32.002H17.484ZM29.312 32.002H30.518C30.297 32.294 30.132 32.629 30.057 33H29.813L29.312 32.002ZM32.486 32.002H32.526C33.35 32.013 34.006 32.672 34.006 33.5C34.006 34.334 33.34 35 32.506 35C31.672 35 31.006 34.334 31.006 33.5C31.006 32.672 31.661 32.012 32.486 32.002ZM34.494 32.002H35.694L35.194 33H34.955C34.8784 32.6371 34.7202 32.296 34.494 32.002ZM15.496 33C15.3634 33 15.2362 33.0527 15.1424 33.1464C15.0487 33.2402 14.996 33.3674 14.996 33.5C14.996 33.6326 15.0487 33.7598 15.1424 33.8536C15.2362 33.9473 15.3634 34 15.496 34C15.6286 34 15.7558 33.9473 15.8496 33.8536C15.9433 33.7598 15.996 33.6326 15.996 33.5C15.996 33.3674 15.9433 33.2402 15.8496 33.1464C15.7558 33.0527 15.6286 33 15.496 33ZM32.506 33C32.3734 33 32.2462 33.0527 32.1524 33.1464C32.0587 33.2402 32.006 33.3674 32.006 33.5C32.006 33.6326 32.0587 33.7598 32.1524 33.8536C32.2462 33.9473 32.3734 34 32.506 34C32.6386 34 32.7658 33.9473 32.8596 33.8536C32.9533 33.7598 33.006 33.6326 33.006 33.5C33.006 33.3674 32.9533 33.2402 32.8596 33.1464C32.7658 33.0527 32.6386 33 32.506 33Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.sufficiencyMetrics") }}
              </span>
            </router-link>
          </li> -->

          <!-- MANAGE USERS -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('EngineeringManager') &&
                comPlanFeatures.includes('Manage users')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Manage users')) ||
                (userDetails.roles.includes('RegionalEngineer') &&
                  comPlanFeatures.includes('Manage users')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'company_users' ? 'navbar_item_active' : null
            "
          >
            <router-link
              :to="{
                name: 'branch_users',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
              :class="
                activeRoute === 'company_users' ? 'navbar_item_active' : ''
              "
            >
              <span class="mr-2 icon">
                <img src="@/assets/img/users-group.png" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.manageUsers") }}
              </span>
            </router-link>
          </li>

          <!-- FAULTS -->
          <li
            class="list-group-item"
            :class="
              activeRoute === 'faults-maintenance' ? 'navbar_item_active' : ''
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('EngineeringManager') &&
                comPlanFeatures.includes('Faults')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Faults')) ||
                (userDetails.roles.includes('RegionalEngineer') &&
                  comPlanFeatures.includes('Faults')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'faults-maintenance',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
              :class="activeRoute === 'pumps' ? 'active' : ''"
            >
              <span class="mr-2"
                ><svg
                  width="25"
                  height="25"
                  viewBox="0 0 202 205"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.201 0L0 10.302L17.9702 41.6866L29.6241 39.9605L100.759 111.808L94.6914 117.692C91.5837 120.831 91.5837 125.586 94.6914 128.724L97.8457 131.917C100.953 135.056 105.708 135.056 108.039 131.917L117.269 141.231C116.492 145.938 117.269 151.533 121.153 155.456L163.154 197.629C171.7 206.26 185.685 206.26 194.231 197.629C204.331 188.214 204.238 174.138 195.691 165.507L153.932 123.083C150.047 119.16 144.508 117.59 139.846 119.16L129.645 109.846C131.976 106.708 131.976 101.906 129.645 99.5442L126.732 96.6097C126.025 95.8659 125.177 95.274 124.239 94.8697C123.3 94.4654 122.29 94.257 121.27 94.257C120.25 94.257 119.24 94.4654 118.301 94.8697C117.362 95.274 116.514 95.8659 115.808 96.6097L110.712 101.757L39.5765 29.9174L41.2702 18.1482L10.1932 0L10.201 0ZM161.701 0.243231C146.372 -1.04354 126.048 9.21923 116.538 18.1403C104.838 29.9566 106.749 45.4057 116.049 60.3212L99.5472 76.9943L111.201 90.2308C117.416 84.7385 126.584 84.7385 132.799 90.2308L135.962 93.4163L136.692 94.1539L143.49 87.2885C157.537 95.6289 172.158 96.8294 183.307 85.5702C194.184 75.3702 205.978 50.2154 200.539 35.3077L178.692 58.1086C175.585 61.2471 170.876 61.2471 167.769 58.1086L145.184 35.3077C144.447 34.5944 143.861 33.7381 143.461 32.7902C143.06 31.8423 142.854 30.8224 142.854 29.7918C142.854 28.7613 143.06 27.7414 143.461 26.7935C143.861 25.8456 144.447 24.9893 145.184 24.276L167.777 1.47508C165.834 0.784615 163.892 0.431539 161.701 0.243231ZM76.2395 98.0769L48.0682 126.519C45.041 125.84 41.9471 125.511 38.8462 125.538C17.0923 125.538 0 142.8 0 164.769C0 186.738 17.0923 204 38.8462 204C60.6 204 77.6923 186.738 77.6923 164.769C77.6923 160.744 77.063 156.876 75.9909 153.243L92.5005 136.57L90.0765 133.385C83.8611 127.108 83.9077 117.598 89.3462 111.313L76.2317 98.0769H76.2395ZM136.451 133.879C137.422 133.879 138.339 134.067 139.116 134.86L185.009 181.199C186.563 182.768 186.563 185.263 185.009 186.833C183.455 188.402 180.969 188.402 179.415 186.833L133.538 140.493C131.984 138.924 131.984 136.429 133.538 134.86C134.314 134.075 135.48 133.879 136.451 133.879ZM44.1914 144.408L58.9995 159.371L53.6543 179.716L33.5087 185.114L18.6928 170.152L24.038 149.807L44.1914 144.408V144.408Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.faultsAndMaintenance") }}
              </span>
            </router-link>
          </li>

          <!-- PUMP -->
          <li
            class="list-group-item treeview"
            v-show="
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('BranchPump') &&
                comPlanFeatures.includes('Pump')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Pump')) ||
                (userDetails.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Pump')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'branch_pump_maintenance' ||
              activeRoute === 'pump_details' ||
              activeRoute === 'pump_transactions' ||
              activeRoute === 'pumps'
                ? 'navbar_item_active'
                : null
            "
          >
            <router-link
              :to="{
                name: 'pumps',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: $route.query.companyId,
                  dealerId: this.$route.query.dealerId,
                  groupId: this.$route.query.groupId,
                  regionId: this.$route.query.regionId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2 icon">
                <img src="@/assets/img/pump__icon.png" width="20" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.pumps") }}
              </span>

              <!-- <i class="fa fa-angle-right sidenav_arrow"></i> -->
            </router-link>

            <!-- <div>
              <ul class="treeview-menu">
                <li>
                  <router-link
                    :to="{
                      name: 'pumps',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="activeRoute === 'pumps' ? 'active' : ''"
                  >
                    {{ $t("text.bMasterLayout.pumps") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'pump_fault',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="activeRoute === 'pump_fault' ? 'active' : ''"
                  >
                    {{ $t("text.bMasterLayout.pumpFaults") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'branch_pump_maintenance',
                      query: this.$route.query.branchId
                        ? {
                            branchId: this.$route.query.branchId,
                            companyId: $route.query.companyId,
                          }
                        : null,
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'branch_pump_maintenance' ? 'active' : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.pumpMaintenance") }}
                  </router-link>
                </li>
              </ul>
            </div> -->
          </li>

          <!-- BANK -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('ManageBranchPayments') &&
                comPlanFeatures.includes('Bank')) ||
                (userDetails.roles.includes('DealerManageBranchPayments') &&
                  comPlanFeatures.includes('Bank')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Bank')) ||
                (userDetails.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Bank')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'bank_accounts' ||
              activeRoute === 'BranchTerminals' ||
              activeRoute === 'branch-bank-account-request'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img
                  src="@/assets/img/bank-building (2) (2).svg"
                  width="20px"
                />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.bank") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <!-- <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branch_bank_deposits',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.bankDeposits") }}
                  </router-link>
                </li> -->

                <li
                  v-if="
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'BranchTerminals',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'BranchTerminals'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.posTerminals") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branch-bank-account-request',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.cMasterLayout.bankAcctRequest") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'bank_accounts',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.bankAccounts") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- SETTLEMENT -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('ManageBranchPayments') &&
                comPlanFeatures.includes('Settlement')) ||
                (userDetails.roles.includes('DealerManageBranchPayments') &&
                  comPlanFeatures.includes('Settlement')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
            :class="
              activeRoute === 'BranchSettlementRequest'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/wallet (6).svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bSettlement.settlement") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'BranchSettlementRequest',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bSettlement.settlementRequest") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- BRANCH WALLET ALONE -->
          <li
            class="list-group-item treeview"
            v-show="
              allowedEmails.indexOf(userDetails.email) === -1 &&
              userDetails.roles.includes('viewESales') &&
              userDetails.roles.includes('Supervisor')
            "
            :class="
              activeRoute === 'branch_wallet' ||
              activeRoute === 'settlement_account'
                ? 'navbar_item_active'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/e-channel.png" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.eChannel") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userDetails.roles.includes('viewESales') &&
                    userDetails.roles.includes('Supervisor')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branch_wallet',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    <!-- {{ $t("text.bMasterLayout.eSales") }} -->
                    {{ $t("text.omit.remisSales") }}
                  </router-link>
                </li>
                <!-- <li
                  v-if="
                    userDetails.roles.includes('ManageBranchPayments') ||
                    userDetails.roles.includes('DealerManageBranchPayments') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('ViewOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'settlement_account',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.settlementAccount") }}
                  </router-link>
                </li> -->
              </ul>
            </div>
          </li>

          <!-- MANAGEMENT -->
          <li
            class="list-group-item treeview"
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('viewESales') &&
                comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('ManagePayments') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('ViewOutlet') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('ManageStaff') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('DealerManageStaff') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('ManageShift') &&
                  comPlanFeatures.includes('Management')) ||
                (userDetails.roles.includes('DealerManageStaffShift') &&
                  comPlanFeatures.includes('Management')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('ViewBankDeposit') ||
                userDetails.roles.includes('PartnerAdmin') ||
                userDetails.roles.includes('Sub Branch Manager'))
            "
            :class="
              activeRoute === 'expenses' ||
              activeRoute === 'staff' ||
              activeRoute === 'shift' ||
              activeRoute === 'link-branch-bank' ||
              activeRoute === 'branch_assets' ||
              activeRoute === 'branch_price_managers' ||
              activeRoute === 'generate-bank-deposit'
                ? 'navbar_item_active' ||
                  activeRoute === 'add-bank-linked-deposit'
                : null
            "
          >
            <a href="#" class="vue_router_link has-submenu">
              <span class="mr-2 icon">
                <img src="@/assets/img/briefcase.svg" width="20px" />
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.management") }}
              </span>

              <i class="fa fa-angle-right sidenav_arrow"></i>
            </a>
            <div>
              <ul class="treeview-menu">
                <li
                  v-if="
                    userDetails.roles.includes('Sub Branch Manager') ||
                    userDetails.roles.includes('ViewBankDeposit') ||
                    userDetails.roles.includes('ManagePayments') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'generate-bank-deposit',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.createDepositReference") }}
                  </router-link>
                </li>

                <!-- BRANCH WALLET TRANSACTION HISTORY -->
                <li
                  v-if="
                    // userDetails.roles.includes('viewESales') ||
                    userDetails.roles.includes('ManagePayments') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branchTransactions',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'branchTransactions'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.walletTransactions") }}
                  </router-link>
                </li>

                <!-- SETTLEMENT TRANSACTIONS HISTORY -->

                <li
                  v-if="
                    // userDetails.roles.includes('viewESales') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branchSettlementTransactions',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: this.$route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'branchSettlementTransactions'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.settlementTransactions") }}
                  </router-link>
                </li>

                <li
                  v-if="
                    userDetails.roles.includes('ManagePayments') ||
                    userDetails.roles.includes('ManageExpense') ||
                    userDetails.roles.includes('Expense') ||
                    userDetails.roles.includes('ViewExpense') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'expenses',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.expenses") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userDetails.roles.includes('ManageStaff') ||
                    userDetails.roles.includes('DealerManageStaff') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'staff',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.staff") }}
                  </router-link>
                </li>
                <li
                  v-if="
                    userDetails.roles.includes('ManageShift') ||
                    userDetails.roles.includes('DealerManageStaffShift') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'shift',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    {{ $t("text.bMasterLayout.shift") }}
                  </router-link>
                </li>

                <!-- BRANCH ASSETS -->
                <li
                  v-if="
                    userDetails.roles.includes('ViewAsset') ||
                    userDetails.roles.includes('DealerViewAsset') ||
                    userDetails.roles.includes('ManageOutlet') ||
                    userDetails.roles.includes('SupportAdmin') ||
                    userDetails.roles.includes('PartnerAdmin')
                  "
                >
                  <router-link
                    :to="{
                      name: 'branch_assets',
                      query: {
                        branchId: this.$route.query.branchId,
                        companyId: $route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                    :class="
                      activeRoute === 'branch_assets'
                        ? 'navbar_item_active'
                        : ''
                    "
                  >
                    {{ $t("text.bMasterLayout.assets") }}
                  </router-link>
                </li>

                <li>
                  <router-link
                    :to="{
                      name: 'branch_price_managers',
                      query: {
                        entityType: 'Branch',
                        branchId: this.$route.query.branchId,
                        companyId: this.$route.query.companyId,
                        dealerId: this.$route.query.dealerId,
                        groupId: this.$route.query.groupId,
                        regionId: this.$route.query.regionId,
                      },
                    }"
                    class="vue_router_link"
                  >
                    <span class="sidenav_list_title">
                      {{ $t("text.priceManager.title") }}
                    </span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- INVOICES -->
          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'branch_invoice' ? 'navbar_item_active' : ''
            "
            v-show="
              userDetails.email !== 'supportest@gmail.com' &&
              allowedEmails.indexOf(userDetails.email) === -1 &&
              ((userDetails.roles.includes('ViewInvoices') &&
                comPlanFeatures.includes('Invoices')) ||
                (userDetails.roles.includes('DealerViewInvoices') &&
                  comPlanFeatures.includes('Invoices')) ||
                (userDetails.roles.includes('ManageOutlet') &&
                  comPlanFeatures.includes('Invoices')) ||
                userDetails.roles.includes('SupportAdmin') ||
                userDetails.roles.includes('PartnerAdmin'))
            "
          >
            <router-link
              :to="{
                name: 'branch_invoice',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/invoice.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.invoices") }}
              </span>
            </router-link>
          </li> -->

          <!-- <li
            class="list-group-item"
            :class="activeRoute === 'branch_assets' ? 'navbar_item_active' : ''"
            v-if="
              userDetails.roles.includes('ViewAsset') ||
              userDetails.roles.includes('DealerViewAsset') ||
              userDetails.roles.includes('ManageOutlet') ||
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'branch_assets',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/Asset.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.assets") }}
              </span>
            </router-link>
          </li> -->
          <!-- <li
            class="list-group-item"
            v-if="userDetails.roles.includes('IndustryManager')"
            :class="
              activeRoute === 'IndustrialBranchDashboard'
                ? 'navbar_item_active'
                : ''
            "
          >
            <router-link
              :to="{
                name: 'IndustrialBranchDashboard',
                query: this.$route.query.branchId
                  ? { branchId: this.$route.query.branchId, companyId: $route.query.companyId }
                  : null,
              }"
              class="vue_router_link"
            >
              <span class=""
                ><i
                  class="mr-2 text-sm text-white fa fa-cogs"
                  aria-hidden="true"
                ></i
              ></span>
              <span class="sidenav_list_title"> Generator System </span>
            </router-link>
          </li> -->

          <!-- SUPPORT -->
          <li
            v-if="
              userDetails.roles.includes('SupportAdmin') ||
              userDetails.roles.includes('PartnerAdmin')
            "
            class="list-group-item"
            :class="
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/svg/support.svg" width="20px" />
                <!-- <img
                  src="https://test-admin.epump.ng/img/profile.c07aa991.svg"
                  width="20px"
                /> -->
              </span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.supportAdmin") }}
              </span>
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="100px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="100px"
                  height="40px"
                />
              </div>
            </div>
          </div>
          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'branchSettings' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'branchSettings',
                query: this.$route.query.branchId
                  ? { branchId: this.$route.query.branchId, companyId: $route.query.companyId }
                  : null,
              }
              "
              class="vue_router_link"
            >
              <span class="mr-2">
                <img src="@/assets/img/admin.png" width="20px" />
              </span>
              <span class="sidenav_list_title"> Branch settings </span>
            </router-link>
          </li> -->

          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <a href="" class="vue_router_link">
              <span class="mr-2"
                ><i
                  class="mr-3 fa fa-sign-out"
                  style="font-size: 20px; color: white"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.bMasterLayout.logout") }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import configObject from "@/config";
import countryProducts from "@/products";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
// import terminalsVue from "./POS/terminals.vue";
import StarRating from "vue-star-rating";

export default {
  name: "MasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    StarRating,
  },
  data() {
    return {
      statusInfo: {},
      LogoUrl,
      startDate: this.$moment()
        .subtract(30, "days")
        .format("YYYY-MM-DDTHH:mm:ss"),
      endDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      dateRange: { start: this.startDate, end: this.endDate },
      masterbackgroundUrl,
      branchIcon: "",
      starSize: 20,
      companyIcon: null,
      showPumpsFaultDropdown: false,
      showReportsDropDownHover: false,
      branch: { name: "STATION" },
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      isIndustryManager: false,
      companyId: null,
      branchRating: 0,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
      PriceApproval: JSON.parse(localStorage.getItem("PriceApproval")),
      allowedEmails: [
        "demonstration@gmail.com",
        "demo1@gmail.com",
        "demo2@gmail.com",
        "Demo3@gmail.com",
        "demo4@gmail.com",
      ],
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
    companyId() {
      this.checkStatus();
    },
    branch: {
      handler(branch) {
        this.getBranchRatings();
      },
      deep: true,
    },
  },
  computed: {
    userDetails: {
      get() {
        const user = localStorage.getItem("userDetails")
          ? JSON.parse(localStorage.getItem("userDetails"))
          : null;

        if (user) {
          if (!user.roles) {
            if (user.role) {
              user.roles = user.role.split(",");
              localStorage.setItem("userDetails", JSON.stringify(user));
            }
          }
        }
        return user;
      },
      set(value) {},
    },
    userName: {
      get() {
        return `${this.userDetails.firstName}  ${this.userDetails.lastName}`;
      },
      set(value) {},
    },
  },
  // checkthis
  created() {
    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
      this.$eventHub.$emit("companyId", this.$route.query.companyId);
    }

    // here
    if (this.$route.query.branchId && this.$route.query.dealerId) {
      this.checkStatus();
      const useId = this.$route.query.dealerId
        ? this.$route.query.dealerId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerBranches/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyBranch = response.data.filter(
            (cur) => cur.id === this.$route.query.branchId,
          );
          this.branch = companyBranch[0];
          this.$eventHub.$emit("branch", this.branch);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.errorOccured"),
              type: "error",
              duration: 5000,
            });
          }
        });
    } else if (this.$route.query.branchId && this.$route.query.groupId) {
      this.checkStatus();
      const useId = this.$route.query.groupId ? this.$route.query.groupId : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/GroupBranches/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyBranch = response.data.filter(
            (cur) => cur.id === this.$route.query.branchId,
          );
          this.branch = companyBranch[0];
          this.$eventHub.$emit("branch", this.branch);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.errorOccured"),
              type: "error",
              duration: 5000,
            });
          }
        });
    } else if (this.$route.query.branchId && this.$route.query.regionId) {
      this.checkStatus();
      const useId = this.$route.query.regionId
        ? this.$route.query.regionId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/RegionBranches/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyBranch = response.data.filter(
            (cur) => cur.id === this.$route.query.branchId,
          );
          this.branch = companyBranch[0];
          this.$eventHub.$emit("branch", this.branch);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.errorOccured"),
              type: "error",
              duration: 5000,
            });
          }
        });
    } else if (this.$route.query.branchId) {
      this.checkStatus();
      const useId = this.$route.query.companyId
        ? this.$route.query.companyId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${useId}`,
          configObject.authConfig(),
        )
        .then((response) => {
          const companyBranch = response.data.filter(
            (cur) => cur.id === this.$route.query.branchId,
          );
          this.branch = companyBranch[0];
          this.$eventHub.$emit("branch", this.branch);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            return;
          }
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.networkError"),
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: this.$t("text.bMasterLayout.errorOccured"),
              type: "error",
              duration: 5000,
            });
          }
        });
    } else {
    }

    // here again
    // if (this.$route.query.branchId) {
    //   this.checkStatus();
    //   const useId = this.$route.query.companyId
    //     ? this.$route.query.companyId
    //     : "";
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Company/Branches/${useId}`,
    //       configObject.authConfig()
    //     )
    //     .then((response) => {
    //       const companyBranch = response.data.filter(
    //         (cur) => cur.id === this.$route.query.branchId
    //       );
    //       this.branch = companyBranch[0];
    //       this.$eventHub.$emit("branch", this.branch);
    //     })
    //     .catch((error) => {
    //       if (error.response && error.response.status == 401) {
    //         return;
    //       }
    //       if (error.message && error.message === "Network Error") {
    //         this.$toast.open({
    //           message: "Network Error, Please Check Your Internet Connection",
    //           type: "error",
    //           duration: 5000,
    //         });
    //       } else {
    //         this.$toast.open({
    //           message: "An Error Occured",
    //           type: "error",
    //           duration: 5000,
    //         });
    //       }
    //     });
    // }

    // here
    if (!this.$route.query.branchId && !this.$route.query.companyId) {
      this.getBranch();
    }

    if (!localStorage.getItem("userDetails")) {
      this.get;
      this.$router.push({ name: "login" });
    }
    if (localStorage.getItem("companyDetails")) {
      this.companyIcon = JSON.parse(localStorage.getItem("companyDetails")).url;
    } else {
      this.companyIcon = null;
    }
  },
  beforeMount() {
    // TO REROUTE TO OLD DASHBOARD FOR OLD CLIENT ROLES
    // if (
    //   this.$route.name == "branchDashboard" &&
    //   this.userDetails.roles.includes("Old Client")
    // ) {
    //   this.$router.push({
    //     name: "branchDashboard1",
    //     query: {
    //       companyId: this.$route.query.companyId,
    //       branchId: this.$route.query.branchId,
    //       groupId: this.$route.query.groupId,
    //       dealerId: this.$route.query.dealerId,
    //       regionId: this.$route.query.regionId,
    //     },
    //   });
    // }

    this.activeRoute = this.$route.name;
  },
  mounted() {
    // select language setup
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    this.dateRange.start = this.startDate;
    this.dateRange.end = this.endDate;
    if (
      this.userDetails.roles.includes("Branch") &&
      !this.$route.query.branchId
    ) {
      this.getBranch();
    }
    if (this.userDetails.roles.includes("IndustryManager")) {
      this.isIndustryManager = true;
    }
    this.computeUserDetails();
    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
    $(".treeview-men > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        // console.log("closed treeview men");
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        // console.log("added class to treeview men");
        $(".treeview-men").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  methods: {
    showNotification() {
      const status = this.statusInfo.status;
      if (
        (status == 1 && !this.userDetails.roles.includes("SupportAdmin")) ||
        this.userDetails.roles.includes("PartnerAdmin")
      )
        this.showWarningModal();
      if (
        (status == 2 && !this.userDetails.roles.includes("SupportAdmin")) ||
        !this.userDetails.roles.includes("PartnerAdmin")
      )
        this.showSuspendedModal();
    },
    checkStatus() {
      const modalShown = this.$store.getters.getBranchModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getBranchStatusInfo;
        return;
      }

      // let compId;

      // if (!this.$route.query.branchId) {
      //   const branches = localStorage.getItem("totalBranches")
      //     ? JSON.parse(localStorage.getItem("totalBranches"))
      //     : null;
      //   if (branches.length) {
      //     compId = branches[0].companyId;
      //   }
      // }

      const endpoint = this.$route.query.branchId
        ? `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }&branchId=${this.$route.query.branchId}`
        : `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }&branchId=${this.branch.id}`;
      this.axios
        .get(endpoint, configObject.authConfig())
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (
              // this.$route.name !== "branch_invoice" &&
              // this.$route.name !== "branch_invoice_details" &&
              // this.$route.name !== "branch_invoice_payments" &&
              !this.userDetails.roles.includes("SupportAdmin") &&
              !this.userDetails.roles.includes("PartnerAdmin")
            ) {
              this.showWarningModal();
              this.$store.commit("setBranchModalShown", true);
            }
          }
          if (response.data.status == 2) {
            if (
              // this.$route.name !== "branch_invoice" &&
              // this.$route.name !== "branch_invoice_details" &&
              // this.$route.name !== "branch_invoice_payments" &&
              !this.userDetails.roles.includes("SupportAdmin") &&
              !this.userDetails.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setBranchStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    changeCountry(e) {
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);

      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value]),
      );
      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },

    signOutUser() {
      const answer = window.confirm(
        this.$t("text.bMasterLayout.confirmLogout"),
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        localStorage.clear();
        this.$router.push({ name: "login" });
      }
    },
    changeRoute(routeName) {
      this.$router.push({
        name: routeName,
        query: this.$route.query.branchId
          ? {
              entityType: "Branch",
              branchId: this.$route.query.branchId,
              companyId: $route.query.companyId,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
            }
          : null,
      });
    },
    getBranchRatings() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Branch/${this.branch.id}?startDate=${this.dateRange.start}&endDate=${this.dateRange.end}`,
          configObject.authConfig(),
        )
        .then((res) => {
          this.showLoader = false;
          this.branchRating = res.data.averageRateValue;
        })
        .catch((e) => {});
    },
    computeUserDetails() {
      if (localStorage.getItem("userDetails")) {
        this.userDetails = JSON.parse(localStorage.getItem("userDetails"));

        this.userName =
          this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        this.userName = "Username";
      }
      if (this.userDetails.roles.includes("Branch Manager")) {
        if (
          this.branch !== null &&
          this.branch.companyLogoUrl !== null &&
          this.branch.companyLogoUrl !== ""
        ) {
          this.branchIcon = this.branch.companyLogoUrl;
        } else {
          this.branchIcon = null;
        }
      } else {
        if (localStorage.getItem("companyDetails")) {
          this.company = JSON.parse(localStorage.getItem("companyDetails"));
          this.branchIcon = this.company.url;
        } else {
          this.branchIcon = null;
        }
      }
    },
    getBranch() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyBranches`,
          configObject.authConfig(),
        )
        .then((response) => {
          localStorage.setItem("totalBranches", JSON.stringify(response.data));

          if (response.data.length > 0) {
            this.branch = response.data[0];
            this.companyId = response.data[0].companyId;

            // Logic for subscription plan feature
            let subPlanFeat;
            let isSubPlanFeat;
            subPlanFeat = response.data[0].planFeatures;
            isSubPlanFeat = localStorage.getItem("subPlanFeatures");
            if (!isSubPlanFeat) {
              localStorage.setItem(
                "subPlanFeatures",
                JSON.stringify(subPlanFeat),
              );
              this.comPlanFeatures = JSON.parse(
                localStorage.getItem("subPlanFeatures"),
              );
            }
            const PriceApproval = response.data[0].priceApproval;
            localStorage.setItem(
              "PriceApproval",
              JSON.stringify(PriceApproval),
            );
            // this.comPlanFeatures = response.data[0].planFeatures;
            // console.log(this.comPlanFeatures);
            // Logic for subscription plan feature ended

            this.$eventHub.$emit("branch", response.data[0]);
            this.computeUserDetails();
            s;
          }
        })
        .catch((error) => {});
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));
      const treeviewz = Array.from(document.querySelectorAll(".treeview-men"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title"),
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
        treeviewz.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
        treeviewz.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));
      const treeviewz = Array.from(document.querySelectorAll(".treeview-men"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
        treeviewz.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },
    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title"),
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
    // logout() {
    //     localStorage.clear();
    //     this.$router.push({name: 'login'});
    // }
  },
};
</script>

<style scoped lang="scss">
.cart-count {
  position: absolute !important;
  top: 13px;
  right: 265px;
  background-color: #4c2e73;
  border-radius: 50%;
}
.badge {
  padding: 0.2em 0.4em;
}
</style>
